var modules_c05201b4 = {"storeButton":"_12c8j8i","bgDark":"_13bz7t3"};
import "../../../assets/C3s1-2g5.css";

export { modules_c05201b4 as default };
//# sourceMappingURL=Store.module.less.js.map
